<div id="toxicologyAlphaResults" style="padding: 8px; height: 100%"  [style.display]="hasResults ? 'block' : 'none'">
    <div style="text-align: center; background-color: rgba(191, 191, 191, 0.15); height: 24px">
        <h5 style="height: 24px">Results</h5>
    </div>
    <dx-tree-list
        #tree
        [dataSource]="dataSource"
        parentIdExpr="parentKey"
        keyExpr="key"
        [(expandedRowKeys)]="expandedKeys"
        [showRowLines]="true"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        [highlightChanges]="true"
        [columnAutoWidth]="true"
        [allowColumnResizing]="true"
        [wordWrapEnabled]="true"
        height="100%"
        [columnHidingEnabled]="isPhoneOrTablet"
    (onContentReady)='onContentReady($event)'>
        <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
      <dxo-scrolling
        mode="standard"
        rowRenderingMode="standard"
        preloadEnabled="true"
      ></dxo-scrolling>

        <dxi-column caption="Name" cellTemplate="nameTemplate" [allowFiltering]="true" [calculateFilterExpression]="calculateNameFilter" [hidingPriority]="isPhoneOrTablet ? 3 : -1"></dxi-column>
        <dxi-column caption="Result" cellTemplate="resultsTemplate" [allowFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 3 : -1"></dxi-column>
        <dxi-column dataField="cutOff" caption="CutOff" [allowFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 0 : -1"></dxi-column>
        <dxi-column dataField="rxVerification" caption="Rx Verification" [allowFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 1 : -1"></dxi-column>

        <div *dxTemplate="let result of 'nameTemplate'">
            {{result.data.name}}
            <span *ngIf="result.data.resultReportComments">
                <p [innerHtml]="transformYourHtml(result.data.resultReportComments)" style="border: 0; padding: 20px; overflow-x: auto" ></p>
            </span>
        </div>

        <div *dxTemplate="let result of 'resultsTemplate'">
            {{result.data.result}}
            <span *ngIf="result.data.comment">
                <p [innerHtml]="transformYourHtml(result.data.comment)" style="border: 0; padding: 20px; overflow-x: auto"></p>
            </span>
        </div>

    </dx-tree-list>
</div>
